import { render, staticRenderFns } from "./Settings.vue?vue&type=template&id=537707ed&scoped=true"
import script from "./Settings.vue?vue&type=script&lang=js"
export * from "./Settings.vue?vue&type=script&lang=js"
import style0 from "./Settings.vue?vue&type=style&index=0&id=537707ed&prod&scoped=true&lang=css"
import style1 from "./Settings.vue?vue&type=style&index=1&id=537707ed&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "537707ed",
  null
  
)

export default component.exports